import { useQuery } from '@tanstack/react-query'

import { useQueryErrorAlert } from '@hooks/useQueryErrorAlert'

import { useAuthenticatedUser } from '../../../auth/hooks/useAuthenticatedUser'
import { fetchProject } from '../services/fetchProject'

export { useProject, queryKey }

const queryKey = 'project'

const useProject = ({ id }: { id: string }) => {
  const { hasPermissions } = useAuthenticatedUser()

  const {
    data,
    isPending: isLoading,
    isError,
    error,
    errorUpdatedAt,
  } = useQuery({
    queryKey: [queryKey, id],
    queryFn: () => fetchProject({ id }),
    enabled: hasPermissions && !!id,
    refetchOnMount: true,
  })

  useQueryErrorAlert(error, errorUpdatedAt, 'Fout bij ophalen van project')

  return {
    data,
    isLoading,
    isError,
  }
}
